


































































import { Component, Prop, Watch } from "vue-property-decorator";
import _ from "lodash";

import AppVue from "@/apps/AppVue.vue";
import {
  CourseSessionModel,
  CourseSessionEducatorModel,
  EligibleEducatorsModel,
} from "@/core/models";
import {
  LicenseService,
} from "@/core/services";

@Component
export default class CourseSessionEducators extends AppVue {
  @Prop() model: CourseSessionModel;
  @Prop() isReadOnly: boolean;
  @Prop({ default: false }) autoAddOrganiser: boolean;

  eligibleEducators: EligibleEducatorsModel = new EligibleEducatorsModel();
  educatorIdToAdd: number | null = null;

  get courseUnionId() {
    return `${this.model.courseId}-${this.model.unionId}`;
  }

  get showEducators() {
    return this.model && this.model.startDate && this.model.courseId && this.model.unionId;
  }

  get showSecondaryEducators() {
    return this.eligibleEducators
      && this.eligibleEducators.secondaryEducators
      && this.eligibleEducators.secondaryEducators.length > 0;
  }

  async created() {
    await this.fetchEligibleEducators();
  }

  onDeleteEducator(userId: number) {
    const educatorIndex = _.findIndex(this.model.educators, {userId});
    if (educatorIndex === -1) {
      return;
    }

    this.model.educators.splice(educatorIndex, 1);
  }

  onAddEducator() {
    if (!this.educatorIdToAdd) {
      return;
    }

    this.addEducator(this.educatorIdToAdd);
    this.educatorIdToAdd = null;
  }

  addEducator(educatorId: number) {
    if (_.find(this.model.educators, {userId: educatorId }) !== undefined) {
      // Educator has already been added
      return;
    }

    if (!this.addEducatorToModel(this.eligibleEducators.educators, educatorId)) {
      this.addEducatorToModel(this.eligibleEducators.secondaryEducators, educatorId);
    }
  }

  addEducatorToModel(educators: CourseSessionEducatorModel[], userId: number) {
    const educator = _.find(educators, {userId});
    if (educator) {
      this.model.educators.push(educator as CourseSessionEducatorModel);
      return true;
    }

    return false;
  }

  @Watch("courseUnionId")
  private async initializeEligibleEducators() {
    if (this.isReadOnly) {
      return;
    }

    this.model.educators = [];

    await this.fetchEligibleEducators();
    const educator = this.getEligibleEducator(this.currentUserId);
    if (!educator) {
      return;
    }

    if (this.autoAddOrganiser) {
      // Add the current user as the organiser of this session
      const currentOrganiser = {
        userId: this.currentUserId,
        user: this.currentUserName,
        licenseId: this.model.licenseId,
        isOrganiser: true,
        isSecondaryEducator: educator.isSecondaryEducator,
      } as CourseSessionEducatorModel;

      this.model.educators.unshift(currentOrganiser);
    }
  }

  private async fetchEligibleEducators() {
    if (this.isReadOnly) {
      return;
    }

    // Get all eligible educators
    this.eligibleEducators = await LicenseService.getEligibleEducators(this.model);
  }

  private getEligibleEducator(userId: number | undefined) {
    const educators = _.concat(
      this.eligibleEducators.educators,
      this.eligibleEducators.secondaryEducators);

    return _.find(educators, {userId});
  }
}
